import styled, { css } from "styled-components";
import { Colors, Fonts, Scale } from '../../themes';
import { deviceSize } from '../../constants/deviceSize'

export const StyledEditForm = styled.div`
  background-color: ${Colors.primaryBgColor};
  padding: 53px 0;
  overflow: auto;
`